import { useQuery } from "app/tools/query/hooks/useQuery";

import { ApplicationVersion } from "../../entity";
import { readVersion } from "./endpoint";

export const useVersionQuery = () => {
  return useQuery<ApplicationVersion>("Verze aplikace", {
    queryFn: readVersion,
    queryKey: ["version"],
    refetchOnMount: false,
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
    retry: 2,
  });
};
